import React, { useEffect, useState } from 'react';
import { useApolloClient } from 'react-apollo';
import { useParams } from 'react-router';

import { ContentFragment, useGetContentLazyQuery } from 'api';
import { Content as LocalContentFragment } from 'api/fragments';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

import PostEdit from './PostEdit';

const PostContentLoader = () => {
  const { content_id } = useParams();
  const notify = useNotify();
  const apolloClient = useApolloClient();
  const [cachedContent, setCachedContent] = useState<ContentFragment>();

  const [getContentQuery, { data, loading }] = useGetContentLazyQuery({
    onError: notify.queryError,
    variables: { content_id },
  });

  function findCachedContent() {
    return apolloClient.readFragment({
      id: content_id,
      fragment: LocalContentFragment,
      fragmentName: 'Content',
    });
  }

  function hasData() {
    return cachedContent || data?.getContent;
  }

  function getContent() {
    return cachedContent || data?.getContent;
  }

  useEffect(() => {
    const cachedContentResult = findCachedContent();
    if (cachedContentResult) {
      setCachedContent(cachedContentResult);
    } else {
      getContentQuery();
    }
  }, []);

  if (loading || !hasData()) {
    return <Loaders.Standard />;
  }

  return <PostEdit content={getContent()} />;
};

export default PostContentLoader;
